<template>
    <!-- Новий дизайн: «Хто платить?» — чотири ігри для компанії. Гравці → гра → результат з картинкою для сторіс.
         Ніяк не пов'язано з оплатою на сайті: просто жарт серед друзів -->
    <div class="bp-wp">
        <BpPageNav title="Хто платить?"/>

        <template v-if="step == 'setup'">
            <h1 class="bp-wp__h1">Хто платить?</h1>
            <p class="bp-wp__lead">Замовляєте компанією? Впишіть імена, оберіть гру — і хай вирішить піца.</p>

            <section class="bp-wp-card" aria-labelledby="bp-wp-players">
                <h2 class="bp-wp-card__title" id="bp-wp-players">Гравці <span class="bp-wp-card__count">{{ names.length }}</span></h2>
                <div class="bp-wp-names">
                    <div v-for="(name, i) in names" :key="i" class="bp-wp-name">
                        <span class="bp-wp-name__n">{{ i + 1 }}</span>
                        <input class="bp-wp-name__input" type="text" maxlength="16" v-model="names[i]" :placeholder="'Гравець ' + (i + 1)"
                               :aria-label="'Ім\'я гравця ' + (i + 1)" autocomplete="off" @keydown.enter.prevent="addOnEnter(i)" :ref="'name' + i">
                        <button type="button" class="bp-wp-name__x" v-if="names.length > 2" :aria-label="'Прибрати гравця ' + (i + 1)"
                                @click="names.splice(i, 1)" v-html="icons.close"></button>
                    </div>
                </div>
                <button type="button" class="bp-wp-add" v-if="names.length < 8" @click="addPlayer()"><span v-html="icons.plus"></span>Додати гравця</button>
            </section>

            <h2 class="bp-wp__h2">Оберіть гру</h2>
            <template v-for="group in groups">
            <h3 class="bp-wp__h3" :key="'h-' + group.key">{{ group.name }}</h3>
            <div class="bp-wp-games" :key="'g-' + group.key">
                <button v-for="game in group.games" :key="game.key" type="button" class="bp-wp-gcard" @click="play(game.key)">
                    <span class="bp-wp-gcard__ic" v-html="game.icon"></span>
                    <span class="bp-wp-gcard__name">{{ game.name }}</span>
                    <span class="bp-wp-gcard__text">{{ game.text }}</span>
                    <span class="bp-wp-gcard__go">Грати<span v-html="icons.chevronRight"></span></span>
                </button>
            </div>
            </template>
        </template>

        <template v-else-if="step == 'play'">
            <div class="bp-wp-bar">
                <h1 class="bp-wp__h1 bp-wp__h1--game">{{ gameInfo.name }}</h1>
                <button type="button" class="bp-wp-link" @click="step = 'setup'">Інша гра</button>
            </div>
            <component :is="gameInfo.component" :key="round" :players="players" v-bind="gameInfo.photo ? { photo } : {}" @done="finish"/>
        </template>

        <template v-else>
            <div class="bp-wp-result" role="status">
                <span class="bp-wp-result__chili" v-html="chili" aria-hidden="true"></span>
                <p class="bp-wp-result__kicker">Сьогодні платить</p>
                <p class="bp-wp-result__name">{{ players[result.loser] }}</p>
                <p class="bp-wp-result__note">{{ gameInfo.name }} · {{ result.note }}</p>
                <div class="bp-wp-result__btns">
                    <button type="button" class="bp-wp-btn bp-wp-btn--main" @click="play(game)">Зіграти ще</button>
                    <button type="button" class="bp-wp-btn" @click="share()"><span v-html="icons.chat"></span>{{ shareLabel }}</button>
                    <button type="button" class="bp-wp-btn" @click="step = 'setup'">Інша гра</button>
                </div>
                <router-link class="bp-wp-link bp-wp-result__menu" :to="{ name: 'pizza', params: $route.params }">До меню — замовити піцу</router-link>
            </div>
        </template>
    </div>
</template>

<script>
import BpPageNav from '@/components/BpPageNav.vue'
import GamePepper from '@/components/whopays/GamePepper.vue'
import GameWheel from '@/components/whopays/GameWheel.vue'
import GameDice from '@/components/whopays/GameDice.vue'
import GameReaction from '@/components/whopays/GameReaction.vue'
import GameHot from '@/components/whopays/GameHot.vue'
import GameGuess from '@/components/whopays/GameGuess.vue'
import GameQuiz from '@/components/whopays/GameQuiz.vue'
import GameStop from '@/components/whopays/GameStop.vue'
import GameSticks from '@/components/whopays/GameSticks.vue'
import GameTap from '@/components/whopays/GameTap.vue'
import { CHILI, CHILI_LINE } from '@/components/whopays/chili'
import { ICONS } from '@/v2icons'

const STORE_KEY = 'bpWhoPaysNames';

// group: luck — чистий жереб, skill — спритність і кмітливість; photo — гра показує фото піци з меню
const GAMES = [
    { key: 'pepper', photo: true, group: 'luck', name: 'Скибка з перчиком', text: 'Під однією скибкою — перчик. По черзі тицяйте в скибки: кому дістанеться, той платить', component: GamePepper, icon: CHILI_LINE },
    { key: 'wheel', group: 'luck', name: 'Піца-рулетка', text: 'Скибки з іменами, піца крутиться — на кого вкаже стрілка, той платить', component: GameWheel, icon: ICONS.pizzaSlice },
    { key: 'dice', group: 'luck', name: 'Дуель на кубиках', text: 'Кожен кидає кубик. Найменше — платить, нічия — перекидають', component: GameDice, icon: ICONS.dice },
    { key: 'sticks', group: 'luck', name: 'Палички', text: 'З коробки стирчать хлібні палички, одна коротка. Кому дісталась — той платить', component: GameSticks, icon: ICONS.sticks },
    { key: 'hot', photo: true, group: 'luck', name: 'Гаряча піца', text: 'Передавайте піцу одне одному. Таймер прихований: у кого обпече — той платить', component: GameHot, icon: ICONS.flame },
    { key: 'reaction', photo: true, group: 'skill', name: 'Хто повільніший', text: 'Чекайте піцу й тисніть, щойно з\'явиться. Найповільніший платить', component: GameReaction, icon: ICONS.clock },
    { key: 'tap', photo: true, group: 'skill', name: 'Наріж піцу', text: '5 секунд тицяйте в піцу якомога швидше. Найменше розрізів — платить', component: GameTap, icon: ICONS.pizzaCutter },
    { key: 'stop', photo: true, group: 'skill', name: 'Стоп-піца', text: 'Зупиніть піцу на червоній позначці. Хто найдалі — той платить', component: GameStop, icon: ICONS.target },
    { key: 'guess', group: 'skill', name: 'Вгадай суму чека', text: 'Сума кошика прихована — кожен вгадує. Хто помилився найбільше, той платить', component: GameGuess, icon: ICONS.receipt },
    { key: 'quiz', group: 'skill', name: 'Вікторина по меню', text: 'По 3 питання про наші піци кожному. Найменше правильних — платить', component: GameQuiz, icon: ICONS.question }
];
const GROUPS = [{ key: 'luck', name: 'На удачу' }, { key: 'skill', name: 'На спритність і кмітливість' }];

export default {
    name: 'WhoPays',
    components: { BpPageNav },
    data() {
        let names = [];
        try { names = JSON.parse(localStorage.getItem(STORE_KEY)) || []; } catch (e) { names = []; }
        if (!Array.isArray(names) || names.length < 2) names = ['', '', ''];
        return {
            icons: ICONS,
            chili: CHILI,
            groups: GROUPS.map(group => Object.assign({}, group, { games: GAMES.filter(game => game.group == group.key) })),
            names: names.slice(0, 8).map(String),
            step: 'setup',
            game: null,
            round: 0,
            result: null,
            shareLabel: 'Поділитися'
        }
    },
    computed: {
        players() {
            return this.names.map((name, i) => name.trim() || 'Гравець ' + (i + 1));
        },
        gameInfo() {
            return GAMES.find(game => game.key == this.game) || GAMES[0];
        },
        // Фото для «Скибки з перчиком» і «Хто повільніший» — випадкова піца з меню, що має справжнє фото
        photo() {
            const pizzas = (this.$store.state.products || []).filter(p => p.category_id == 1 && p.is_hidden == 0 && p.thumbnail && !/placeholder/i.test(p.thumbnail));
            if (!pizzas.length) return '';
            return pizzas[this.round % pizzas.length].thumbnail;
        }
    },
    // Фото піц для «Скибки з перчиком» і «Хто повільніший»: відкрили сторінку напряму — меню ще не завантажене
    mounted() {
        this.$store.dispatch('getProducts').catch(() => { /* без фото — малюємо основу піци */ });
    },
    watch: {
        names: {
            deep: true,
            handler(names) {
                try { localStorage.setItem(STORE_KEY, JSON.stringify(names)); } catch (e) { /* приватний режим — не пам'ятаємо */ }
            }
        }
    },
    methods: {
        addPlayer() {
            this.names.push('');
            this.$nextTick(() => { const el = this.$refs['name' + (this.names.length - 1)]; if (el && el[0]) el[0].focus(); });
        },
        addOnEnter(i) {
            if (i == this.names.length - 1 && this.names.length < 8 && this.names[i].trim()) this.addPlayer();
            else { const el = this.$refs['name' + (i + 1)]; if (el && el[0]) el[0].focus(); }
        },
        play(key) {
            this.game = key;
            this.round++;
            this.result = null;
            this.shareLabel = 'Поділитися';
            this.step = 'play';
            window.scrollTo(0, 0);
        },
        finish(result) {
            this.result = result;
            this.step = 'result';
            window.scrollTo(0, 0);
        },

        // Картинка для сторіс 1080×1920: логотип, «Сьогодні платить», ім'я, гра, адреса сайту
        storyImage() {
            return new Promise(resolve => {
                const W = 1080, H = 1920, c = document.createElement('canvas');
                c.width = W; c.height = H;
                const g = c.getContext('2d');
                g.fillStyle = '#1c1a1a'; g.fillRect(0, 0, W, H);
                g.fillStyle = '#AB2321'; g.fillRect(0, H - 24, W, 24);
                const font = (w, s) => w + ' ' + s + 'px Inter, "Helvetica Neue", Arial, sans-serif';
                const draw = (logo, chili) => {
                    // Логотип широкий (1618×365) — зберігаємо пропорції
                    if (logo) { const w = 620, h = w * logo.naturalHeight / logo.naturalWidth; g.drawImage(logo, (W - w) / 2, 230, w, h); }
                    if (chili) g.drawImage(chili, W / 2 - 110, 500, 220, 220);
                    g.textAlign = 'center';
                    g.fillStyle = '#b3aea8'; g.font = font(600, 56); g.fillText('Сьогодні за піцу платить', W / 2, 840);
                    const name = this.players[this.result.loser];
                    let size = 180; g.font = font(800, size);
                    while (g.measureText(name).width > W - 140 && size > 70) { size -= 8; g.font = font(800, size); }
                    g.fillStyle = '#f0574a'; g.fillText(name, W / 2, 840 + 50 + size);
                    g.fillStyle = '#f1efea'; g.font = font(500, 46); g.fillText(this.gameInfo.name, W / 2, 1210);
                    g.fillStyle = '#b3aea8'; g.font = font(500, 42); g.fillText(this.result.note, W / 2, 1280);
                    g.fillStyle = '#b3aea8'; g.font = font(600, 52); g.fillText('pizza.black · Хто платить?', W / 2, 1700);
                    c.toBlob(resolve, 'image/png');
                };
                const load = src => new Promise(done => { const img = new Image(); img.onload = () => done(img); img.onerror = () => done(null); img.src = src; });
                const chili = CHILI.replace('<svg ', '<svg xmlns="http://www.w3.org/2000/svg" width="220" height="220" ');
                Promise.all([load(require('@/assets/logo_site_white.webp')), load('data:image/svg+xml;charset=utf-8,' + encodeURIComponent(chili))])
                    .then(([logo, pepper]) => draw(logo, pepper));
            });
        },
        async share() {
            const blob = await this.storyImage();
            if (!blob) return;
            const file = new File([blob], 'black-pizza-hto-platyt.png', { type: 'image/png' });
            const text = 'Сьогодні за піцу платить ' + this.players[this.result.loser] + ' 🌶 pizza.black';
            try {
                if (navigator.canShare && navigator.canShare({ files: [file] })) {
                    await navigator.share({ files: [file], text });
                    return;
                }
            } catch (e) {
                if (e && e.name == 'AbortError') return;
            }
            // Комп'ютер без «Поділитися» — зберігаємо картинку
            const a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = file.name;
            document.body.appendChild(a);
            a.click();
            setTimeout(() => { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
            this.shareLabel = 'Картинку збережено';
        }
    }
}
</script>
